export enum HttpStatusCode {
  Ok = 200,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  NotFound = 404,
  UnprocessableEntity = 422,
  TooManyRequests = 429,
  InternalServerError = 500,
  BadGateway = 502,
  ServiceUnavailable = 503,
  Unknown = 520,
}

export enum HttpErrorName {
  BadRequest = 'BAD_REQUEST_ERROR',
  Unauthorized = 'UNAUTHORIZED_ERROR',
  Forbidden = 'FORBIDDEN_ERROR',
  NotFound = 'NOT_FOUND_ERROR',
  Unknown = 'UNHANDLED_ERROR',
  UnprocessableEntity = 'UNPROCESSABLE_ENTITY',
}
